// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import React from 'react';

export default function LayoutBackgroundImage({src}: {src: string}) {
  return (
    <img
      src={src}
      srcSet={generateSrcSet(src).join(',')}
      alt=""
      role="presentation"
      style={{
        position: 'fixed',
        zIndex: -1,
        width: '100%',
        height: '100vh',
        objectFit: 'cover',
        objectPosition: 'top',
      }}
    />
  );
}

const generateSrcSet = (src: string) => {
  const {filename, extension} = splitFilename(src);
  const sizes = [300, 600, 900, 1200, 1500, 1800, 2100, 4000, 8000];
  return sizes.map(
    (size) => `${filename}_${size}x${size}_crop_top.${extension} ${size}w`,
  );
};

const splitFilename = (filename: string) => {
  const splitFilename = filename.split('.');
  const extension = splitFilename.pop();
  return {
    filename: splitFilename.join('.'),
    extension,
  };
};
